import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PurchaseRequisitionWorkflowDataService } from '../../demand/service/purchase-requisition-workflow-data.service';
import { WorkflowUtilService, ITaskListPreview } from '@lib/workflow-integration';
import { View } from '@lib/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Logger } from '@lib/util';

@Component({
    selector: 'post-announce-purchase-requisition-task',
    templateUrl: './post-announce-purchase-requisition-task.component.html',
    styleUrls: ['./post-announce-purchase-requisition-task.component.scss'],
    standalone: false
})
export class PostAnnouncePurchaseRequisitionTaskComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly purchaseRequisitionTaskService = inject(PurchaseRequisitionWorkflowDataService);
    private readonly util = inject(WorkflowUtilService);

    public static DEMAND_ID_PARAM_NAME = 'demandId';

    private demandId?: string;
    private readonly retryIn = 1000;

    public getTask(): void {
        if (this.demandId) {
            this.purchaseRequisitionTaskService.getAllTasksForDemand(this.demandId).subscribe({
                next: (tasks: ITaskListPreview[]) => {
                    if (tasks?.length) {
                        // We only handle the first task.
                        // There should never be multiple tasks at this point right after announcing the demand
                        this.util.routeToForm(tasks[0], View.CLIENT, true);
                    } else {
                        // retry in 1 sec
                        Logger.info(
                            'PURCHASE_REQUISITION',
                            `No purchase requisition for demandId ${this.demandId}. Retry in ${
                                this.retryIn / 1000
                            } second(s)`
                        );
                        setTimeout(() => this.getTask(), this.retryIn);
                    }
                },
                error: (res: HttpErrorResponse) => {
                    Logger.error(
                        'PURCHASE_REQUISITION',
                        `Unable to fetch task for purchase requisition. HttpStatus: ${res.status}`
                    );
                    this.util.routeToList();
                },
            });
        }
    }

    ngOnInit(): void {
        this.demandId = this.route.snapshot.params[PostAnnouncePurchaseRequisitionTaskComponent.DEMAND_ID_PARAM_NAME];
        this.getTask();
    }
}
